import { useDocumentInstance } from 'bridge';
import { SuperSchedule, Competition } from 'business';

export default function useCompetitionSchedule(competition?: Competition | null) : SuperSchedule | null | undefined {
    const superScheduleRef = competition?.superScheduleRef;
    const schedule : SuperSchedule | null | undefined = useDocumentInstance('schedules', superScheduleRef);
    return schedule;
}
 